import React, { useEffect, useState } from 'react';
import Icon from '../IconSvg/Icon';
import '../../styles/snackbar.scss';
import { Snackbar as SnackbarType } from '../../../reducers/snackbarSlice';
import SnackbarTimer from './SnackbarTimer';
import { HEADER_HEIGHT, CONTAINERS_GAP } from '../../constants';

type Props = {
  snackbarNumber: number;
  snackbar: SnackbarType;
  onCloseSnackbar: (id: string) => void;
};

function Snackbar({
  snackbarNumber,
  snackbar: { id, isOpen, message, type, durationInSeconds = 120 },
  onCloseSnackbar,
}: Props) {
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

  useEffect(() => {
    setIsSnackbarOpen(isOpen);
  }, [isOpen]);

  const handleClose = () => {
    setIsSnackbarOpen(false);
    onCloseSnackbar(id);
  };

  return isSnackbarOpen ? (
    <div
      className={`snackbar slide-from-top ${type}`}
      style={{
        top: `${(1 + snackbarNumber) * (HEADER_HEIGHT + CONTAINERS_GAP)}px`,
      }}
    >
      {durationInSeconds && (
        <SnackbarTimer
          durationInSeconds={durationInSeconds}
          onDurationEnd={handleClose}
        />
      )}
      <Icon name="lely-icon-information" className="snackbar__info-icon" />

      <span className="fs--b-md snackbar__text">{message}</span>
      <Icon
        name="lely-icon-close"
        className="snackbar__close"
        onClick={handleClose}
      />
    </div>
  ) : null;
}

export default Snackbar;
